import { render, staticRenderFns } from "./EvangelioDia.vue?vue&type=template&id=07313694&scoped=true"
import script from "./EvangelioDia.vue?vue&type=script&lang=js"
export * from "./EvangelioDia.vue?vue&type=script&lang=js"
import style0 from "./EvangelioDia.vue?vue&type=style&index=0&id=07313694&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07313694",
  null
  
)

export default component.exports